export default "__VITE_ASSET__oPi3nG6W__"